
export interface News {
   title: string;
   published: string
   link: string
   sentiment: string
   source_name: string
   source_logo: string
}

export interface SentimentParams {
   color: string
   text: string
   icon: string
}

const newsParamsUp: SentimentParams = { 'color': "var(--green-percentage)", 'text': 'a augmenté', 'icon': 'https://uploads-ssl.webflow.com/641b227fcd5cd9726f0781aa/667ad40fad7f4d6c641467cb_trend-up.svg' }
const newsParamsDown: SentimentParams = { 'color': "var(--coral)", 'text': 'a baissé', 'icon': 'https://uploads-ssl.webflow.com/641b227fcd5cd9726f0781aa/667ad409cc8ba948bf6788d7_trend-down.svg' }
const newsParamsDefault: SentimentParams = { 'color': "var(--midnight-blue)", 'text': '', 'icon': 'https://cdn.prod.website-files.com/641b227fcd5cd9726f0781aa/667ad403075b3c10bdbf0690_trend-up.svg' }

export const SentimentParamsOptions = {
   positive: newsParamsUp,
   negative: newsParamsDown,
   neutral: newsParamsDefault
}
